import { createGetApiHook } from "../../../services/api/apiHooks";
import { APIResponseType } from "../../../types/generics/APIResponse.type";

interface StageBookingParams {
  key: (string | number | undefined)[];
  talentId?: string;
  status?: string;
  offset?: number;
  limit?: number;
}

const getStageBookingsUrl = (params?: StageBookingParams): string => {
  const { key: _, ...queryParams } = params ?? {};

  const queryString = new URLSearchParams(
    Object.entries(queryParams).reduce((acc, [k, v]) => {
      if (v !== undefined && v !== null) acc[k] = String(v);
      return acc;
    }, {} as Record<string, string>)
  ).toString();

  return `stagecards/bookings${queryString ? `?${queryString}` : ""}`;
};

export const useGetStageBookings = createGetApiHook<
  APIResponseType<any>,
  StageBookingParams
>(getStageBookingsUrl);

export interface StageBooking {
  id: number;
  stage_card_id: number;
  talent_id: number;
  user_id: number;
  venue_name: string;
  venue_size: string;
  venue_location: string;
  message: string;
  contact_email: string;
  start_date_time: string;
  end_date_time: string;
  payment_status: "Paid" | "Unpaid" | "Failed";
  status: "Active" | "Pending" | "Completed" | "Cancelled";
  first_reminder_sent?: number;
  [key: string]: any; // fallback for unknown props (optional)
}
